import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { jwtInterceptorFn, tokenInterceptorFn } from '@app/core/interceptors/http.interceptor';
import { ModalModule } from 'ngx-bootstrap/modal';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app/app.routes';
import { DefaultPreset } from './default-preset';
import { loaderInterceptor } from '@app/core/interceptors/loader.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(appRoutes),
    provideHttpClient(withInterceptors([tokenInterceptorFn, jwtInterceptorFn, loaderInterceptor])),
    provideAnimations(),
    providePrimeNG({
      theme: {
        preset: DefaultPreset,
        options: {
          darkModeSelector: '.my-app-dark'
        }
      }
    }),
    importProvidersFrom(BrowserModule, BrowserAnimationsModule, ModalModule.forRoot()),
  ]
};